import { ILinkButton } from '@shared/interfaces/link-buttoninterface';

export interface IHeaderLangItem {
  code: string;
  name: string;
}

export const HEADER_LANGUAGES: IHeaderLangItem[] = [
  { code: 'en', name: 'English' },
  { code: 'no', name: 'Norsk' },
  { code: 'es', name: 'Español' },
  { code: 'se', name: 'Svenska' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'da', name: 'Dansk' },
  { code: 'nl', name: 'Dutch' },
];

export const HEADER_USER_MENU: ILinkButton[] = [
  {
    name: 'ACCOUNT.ACCOUNT_LABEL',
    url: '/account',
    icon: 'bueno-account',
    isSubscription: false,
  },
  /* {
    name: 'PAYMENTS.MANAGE_SUBSCRIPTIONS',
    url: '',
    icon: 'bueno-initials-rounded',
    isSubscription: true
  }, */
  {
    name: 'NOTIFICATIONS.TITLE',
    url: '/account/notifications',
    icon: 'bueno-bell',
    isSubscription: false,
  },
];
